import { render } from "./MenuNew.vue?vue&type=template&id=0e13d00a"
import script from "./MenuNew.vue?vue&type=script&lang=js"
export * from "./MenuNew.vue?vue&type=script&lang=js"
script.render = render

export default script